export const closeIfWebview = () => {
  const isMobileWebview = window.navigator.userAgent.indexOf('circles-mobile-app') > -1
  if (isMobileWebview && window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(JSON.stringify({ action: 'close' }));
    return true
  }
  return false
}